(function () {
  'use strict';

  const root = document.querySelector('[data-zan-setups]');
  if (!root) return;

  const jsonEl = document.querySelector('[data-zan-setups-json]');
  if (!jsonEl) return;

  let data;
  try {
    data = JSON.parse(jsonEl.textContent);
  } catch (error) {
    console.error('Zan setups: invalid JSON payload', error);
    return;
  }

  const catalog = root.querySelector('[data-zan-catalog]');
  const config = root.querySelector('[data-zan-config]');
  const coreRows = root.querySelector('[data-zan-core-rows]');
  const accessoryRows = root.querySelector('[data-zan-accessory-rows]');
  const addonRail = root.querySelector('[data-zan-addon-rail]');
  const removedEl = root.querySelector('[data-zan-removed]');
  const fitPoints = root.querySelector('[data-zan-fit-points]');
  const fitList = root.querySelector('[data-zan-fit-list]');
  const dialog = root.querySelector('[data-zan-swap-dialog]');
  const swapOptions = root.querySelector('[data-zan-swap-options]');
  const mobileJump = root.querySelector('[data-zan-mobile-jump]');
  const mobileBar = root.querySelector('[data-zan-mobile-bar]');
  const strings = data.strings || {};
  const discountPercent = Number(data.discountPercent) || 15;
  const moneyFormat = data.moneyFormat || '{{amount}}';
  const MAX_ACCESSORY_UNITS = Infinity;

  let activeBundle = null;
  let state = null;
  let swapRole = null;

  function formatMoney(cents) {
    const amount = (Number(cents) / 100).toFixed(2);
    const amountNoDecimals = String(Math.round(Number(cents) / 100));
    const amountWithComma = amount.replace('.', ',');
    let value = moneyFormat;
    value = value.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithComma);
    value = value.replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals);
    value = value.replace(/\{\{\s*amount\s*\}\}/g, amount);
    return value;
  }

  function cloneProduct(product) {
    if (!product) return null;
    return JSON.parse(JSON.stringify(product));
  }

  function getVariant(product) {
    if (!product || !product.variants || !product.variants.length) return null;
    return (
      product.variants.find(function (variant) {
        return String(variant.id) === String(product.selected_variant_id);
      }) ||
      product.variants.find(function (variant) {
        return variant.available;
      }) ||
      product.variants[0]
    );
  }

  function compact(list) {
    return (list || []).filter(Boolean);
  }

  function buildInitialState(bundle) {
    function withDefaults(product, included) {
      if (!product) return null;
      return Object.assign(cloneProduct(product), { quantity: 1, included: included !== false });
    }

    const next = {
      handle: bundle.handle,
      title: bundle.title,
      fitReason: bundle.fitReason,
      image: bundle.image,
      fitPoints: bundle.fitPoints,
      desk: withDefaults(bundle.desk, true),
      deskAlts: compact(bundle.deskAlts).map(cloneProduct),
      chair: withDefaults(bundle.chair, true),
      chairAlts: compact(bundle.chairAlts).map(cloneProduct),
      accessories: compact(bundle.accessories).map(function (item) {
        return withDefaults(item, true);
      }),
      addons: compact(bundle.addons).map(function (item) {
        return withDefaults(item, false);
      }),
    };
    clampAccessoryUnits(next);
    return next;
  }

  function clampAccessoryUnits(target) {
    const bag = target || state;
    if (!bag) return;
    let used = 0;
    bag.accessories.concat(bag.addons).forEach(function (item) {
      if (!item || !item.included) return;
      const qty = Number(item.quantity) || 1;
      if (used >= MAX_ACCESSORY_UNITS) {
        item.included = false;
        return;
      }
      const allowed = Math.min(qty, MAX_ACCESSORY_UNITS - used);
      item.quantity = Math.max(1, allowed);
      used += item.quantity;
    });
  }

  function includedItems() {
    if (!state) return [];
    return []
      .concat(state.desk && state.desk.included ? [state.desk] : [])
      .concat(state.chair && state.chair.included ? [state.chair] : [])
      .concat(state.accessories.filter(function (item) { return item.included; }))
      .concat(state.addons.filter(function (item) { return item.included; }));
  }

  function calcTotals() {
    const items = includedItems().filter(function (item) {
      const variant = getVariant(item);
      return variant && variant.available;
    });

    let listTotal = 0;
    let count = 0;

    items.forEach(function (item) {
      const variant = getVariant(item);
      const qty = Number(item.quantity) || 1;
      listTotal += Number(variant.price) * qty;
      count += qty;
    });

    const hasDesk = !!(state.desk && state.desk.included && getVariant(state.desk) && getVariant(state.desk).available);
    const hasChair = !!(state.chair && state.chair.included && getVariant(state.chair) && getVariant(state.chair).available);
    const eligible = hasDesk && hasChair;
    const setupTotal = eligible ? Math.round(listTotal * (100 - discountPercent) / 100) : listTotal;
    const saved = Math.max(listTotal - setupTotal, 0);

    return { listTotal: listTotal, setupTotal: setupTotal, saved: saved, count: count, eligible: eligible, items: items };
  }

  function setText(nodes, value) {
    nodes.forEach(function (node) {
      node.textContent = value;
    });
  }

  function setHtml(nodes, value) {
    nodes.forEach(function (node) {
      node.innerHTML = value;
    });
  }

  function updateSummary() {
    const totals = calcTotals();
    const listNodes = root.querySelectorAll('[data-zan-list-total]');
    const setupNodes = root.querySelectorAll('[data-zan-setup-total]');
    const saveAmountNodes = root.querySelectorAll('[data-zan-save-amount]');
    const saveLineNodes = root.querySelectorAll('[data-zan-save-line]');
    const countNodes = root.querySelectorAll('[data-zan-item-count]');
    const eligibility = root.querySelector('[data-zan-eligibility]');
    const discountRows = root.querySelectorAll('[data-zan-discount-row]');
    const saveRows = root.querySelectorAll('[data-zan-save-row]');
    const addLabels = root.querySelectorAll('[data-zan-add-label]');

    setText(countNodes, String(totals.count));
    setHtml(listNodes, formatMoney(totals.listTotal));
    setHtml(setupNodes, formatMoney(totals.setupTotal));
    setHtml(saveAmountNodes, formatMoney(totals.saved));

    const saveLine = totals.eligible
      ? (strings.youSaveAmount || 'You save [amount]').replace('[amount]', formatMoney(totals.saved))
      : '';
    setHtml(saveLineNodes, saveLine);

    discountRows.forEach(function (row) {
      row.hidden = !totals.eligible;
    });
    saveRows.forEach(function (row) {
      row.hidden = !totals.eligible || totals.saved <= 0;
    });

    if (eligibility) {
      eligibility.textContent = totals.eligible ? (strings.eligible || '') : (strings.notEligible || '');
      eligibility.classList.toggle('is-eligible', totals.eligible);
    }

    addLabels.forEach(function (label) {
      label.textContent = totals.eligible
        ? (strings.addSetupSave || ('Add setup and save ' + discountPercent + '%'))
        : (strings.addSelected || 'Add selected items');
    });

    return totals;
  }

  const COLOR_HEX = {
    black: '#1c1c1c',
    white: '#f4f1ea',
    brown: '#8b5a2b',
    'dark brown': '#4a2c14',
    gray: '#8e8e8e',
    grey: '#8e8e8e',
    oak: '#c4a574',
    walnut: '#5d4037',
    beige: '#d8c3a5',
    natural: '#d2b48c',
    cream: '#f5f0e6',
  };

  function variantOptionValues(variant) {
    if (!variant) return [];
    if (variant.options && variant.options.length) return variant.options.slice();
    return String(variant.title || '')
      .split(' / ')
      .map(function (part) {
        return part.trim();
      })
      .filter(Boolean);
  }

  function productOptions(product) {
    return (product.options || []).map(function (option) {
      return {
        name: option.name || '',
        values: (option.values || []).map(function (value) {
          if (value && typeof value === 'object') return String(value.name || '');
          return String(value);
        }),
      };
    });
  }

  function colorHex(value) {
    return COLOR_HEX[String(value || '').trim().toLowerCase()] || '';
  }

  function isColorOption(option) {
    const name = String(option.name || '').toLowerCase();
    if (/color|colour|wood|metal|finish|shade/.test(name)) return true;
    const values = option.values || [];
    return values.length > 0 && values.every(function (value) {
      return !!colorHex(value);
    });
  }

  function findMatchingVariant(product, desired, requiredIndex) {
    const variants = product.variants || [];
    const requiredValue = desired[requiredIndex];

    function score(variant) {
      const opts = variantOptionValues(variant);
      let matchCount = 0;
      for (let i = 0; i < desired.length; i++) {
        if (opts[i] === desired[i]) matchCount += 1;
      }
      return matchCount * 10 + (variant.available ? 1 : 0);
    }

    const pool = variants.filter(function (variant) {
      if (requiredIndex == null || requiredIndex < 0) return true;
      return variantOptionValues(variant)[requiredIndex] === requiredValue;
    });

    const ranked = (pool.length ? pool : variants).slice().sort(function (a, b) {
      return score(b) - score(a);
    });
    return ranked[0] || null;
  }

  function optionValueAvailable(product, optionIndex, value, currentOptions) {
    return (product.variants || []).some(function (variant) {
      if (!variant.available) return false;
      const opts = variantOptionValues(variant);
      if (opts[optionIndex] !== value) return false;
      for (let i = 0; i < currentOptions.length; i++) {
        if (i === optionIndex) continue;
        if (currentOptions[i] && opts[i] !== currentOptions[i]) return false;
      }
      return true;
    });
  }

  function variantSelect(product) {
    if (!product || product.has_only_default_variant || product.variants.length < 2) return '';
    const options = product.variants
      .map(function (variant) {
        return (
          '<option value="' +
          variant.id +
          '"' +
          (String(variant.id) === String(product.selected_variant_id) ? ' selected' : '') +
          (variant.available ? '' : ' disabled') +
          '>' +
          escapeHtml(variant.title) +
          (variant.available ? '' : ' — ' + (strings.unavailable || 'Unavailable')) +
          '</option>'
        );
      })
      .join('');
    return '<select data-zan-variant data-slot="' + escapeAttr(product.slot) + '">' + options + '</select>';
  }

  function variantPicker(product) {
    if (!product || product.has_only_default_variant || product.variants.length < 2) return '';

    const options = productOptions(product);
    const choosable = options.some(function (option) {
      return option.values.length > 1;
    });
    if (!choosable) return variantSelect(product);

    const current = getVariant(product);
    const currentOpts = variantOptionValues(current);

    const groups = options
      .map(function (option, optionIndex) {
        if (option.values.length < 2) return '';
        const showDot = isColorOption(option);
        const chips = option.values
          .map(function (value) {
            const selected = currentOpts[optionIndex] === value;
            const available = optionValueAvailable(product, optionIndex, value, currentOpts);
            const hex = showDot ? colorHex(value) : '';
            return (
              '<button type="button" class="zan-setups__option-chip' +
              (selected ? ' is-selected' : '') +
              (available ? '' : ' is-unavailable') +
              '" data-zan-option data-slot="' +
              escapeAttr(product.slot) +
              '" data-option-index="' +
              optionIndex +
              '" data-value="' +
              escapeAttr(value) +
              '" aria-pressed="' +
              (selected ? 'true' : 'false') +
              '"' +
              (available ? '' : ' title="' + escapeAttr(strings.unavailable || 'Unavailable') + '"') +
              '>' +
              (hex
                ? '<span class="zan-setups__option-dot" style="background:' +
                  escapeAttr(hex) +
                  '" aria-hidden="true"></span>'
                : '') +
              '<span>' +
              escapeHtml(value) +
              '</span>' +
              '</button>'
            );
          })
          .join('');

        return (
          '<div class="zan-setups__option">' +
          '<p class="zan-setups__option-label">' +
          escapeHtml(option.name) +
          '</p>' +
          '<div class="zan-setups__option-values" role="group" aria-label="' +
          escapeAttr(option.name) +
          '">' +
          chips +
          '</div>' +
          '</div>'
        );
      })
      .join('');

    return '<div class="zan-setups__options">' + groups + '</div>';
  }

  function qtyControl(product) {
    if (product.role === 'desk' || product.role === 'chair') return '';
    return (
      '<div class="zan-setups__qty" data-zan-qty data-slot="' +
      escapeAttr(product.slot) +
      '">' +
      '<button type="button" data-zan-qty-dec aria-label="Decrease quantity">−</button>' +
      '<span>' +
      (product.quantity || 1) +
      '</span>' +
      '<button type="button" data-zan-qty-inc aria-label="Increase quantity">+</button>' +
      '</div>'
    );
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(value) {
    return escapeHtml(value).replace(/'/g, '&#39;');
  }

  function findBySlot(slot) {
    if (!state) return null;
    if (state.desk && state.desk.slot === slot) return state.desk;
    if (state.chair && state.chair.slot === slot) return state.chair;
    return (
      state.accessories.find(function (item) { return item.slot === slot; }) ||
      state.addons.find(function (item) { return item.slot === slot; }) ||
      null
    );
  }

  function renderAltCarousel(current, alts, role) {
    const options = [current].concat(alts || []).filter(Boolean);
    if (options.length < 2) return '';

    const cards = options
      .map(function (product) {
        const variant = getVariant(product);
        const image = (variant && variant.featured_image) || product.featured_image || '';
        const isCurrent = current && product.id === current.id;
        const unavailable = !(variant && variant.available);
        return (
          '<button type="button" class="zan-setups__alt-card' +
          (isCurrent ? ' is-current' : '') +
          (unavailable ? ' is-unavailable' : '') +
          '" data-zan-pick-alt="' +
          escapeAttr(product.slot || product.handle) +
          '" data-zan-pick-role="' +
          escapeAttr(role) +
          '"' +
          (isCurrent || unavailable ? ' aria-disabled="true"' : '') +
          (isCurrent ? ' aria-current="true"' : '') +
          '>' +
          (image
            ? '<img src="' + escapeAttr(image) + '" alt="' + escapeAttr(product.title) + '" loading="lazy" width="160" height="160">'
            : '<span class="zan-setups__alt-card-ph" aria-hidden="true"></span>') +
          '<span class="zan-setups__alt-card-title">' +
          escapeHtml(product.title) +
          '</span>' +
          '<span class="zan-setups__alt-card-price">' +
          (variant ? formatMoney(variant.price) : '') +
          (unavailable ? ' · ' + escapeHtml(strings.unavailable || 'Unavailable') : '') +
          '</span>' +
          (isCurrent
            ? '<span class="zan-setups__alt-card-badge">' + escapeHtml(strings.addedShort || 'Selected') + '</span>'
            : '') +
          '</button>'
        );
      })
      .join('');

    return (
      '<div class="zan-setups__alts">' +
      '<p class="zan-setups__alts-label">' +
      escapeHtml(strings.alternatives || 'Alternatives') +
      '</p>' +
      '<div class="zan-setups__alts-track" role="list">' +
      cards +
      '</div>' +
      '</div>'
    );
  }

  function itemPricing(product, eligible) {
    const variant = getVariant(product);
    if (!variant) return null;
    const qty = Number(product.quantity) || 1;
    const list = Number(variant.price) * qty;
    const applyDiscount = !!(eligible && product.included && list > 0);
    const setup = applyDiscount ? Math.round((list * (100 - discountPercent)) / 100) : list;
    const saved = Math.max(list - setup, 0);
    return {
      list: list,
      setup: setup,
      saved: saved,
      discounted: applyDiscount && saved > 0,
    };
  }

  function renderItemPricing(product, eligible) {
    const pricing = itemPricing(product, eligible);
    if (!pricing) return '';

    if (!pricing.discounted) {
      return (
        '<span class="zan-setups__row-price">' +
        formatMoney(pricing.list) +
        '</span>'
      );
    }

    const saveLabel = (strings.itemSave || 'Save [amount]').replace(
      '[amount]',
      formatMoney(pricing.saved)
    );

    return (
      '<div class="zan-setups__row-pricing">' +
      '<span class="zan-setups__row-price">' +
      '<s class="zan-setups__row-list">' +
      formatMoney(pricing.list) +
      '</s>' +
      '<strong class="zan-setups__row-setup">' +
      formatMoney(pricing.setup) +
      '</strong>' +
      '</span>' +
      '<span class="zan-setups__save-badge zan-setups__save-badge--item">' +
      escapeHtml(saveLabel) +
      '</span>' +
      '</div>'
    );
  }

  function renderRow(product, options) {
    options = options || {};
    if (!product) return '';
    const variant = getVariant(product);
    const image = (variant && variant.featured_image) || product.featured_image || '';
    const alts = options.alts || [];
    const removed = !product.included;
    const role = product.role || options.role || 'accessory';
    const eligible = !!options.eligible;

    return (
      '<div class="zan-setups__row-wrap' +
      (options.core ? ' is-core' : '') +
      (removed ? ' is-removed' : '') +
      '">' +
      '<article class="zan-setups__row' +
      (options.core ? ' is-core' : '') +
      '" data-slot="' +
      escapeAttr(product.slot) +
      '">' +
      (image
        ? '<img class="zan-setups__row-image" src="' + escapeAttr(image) + '" alt="' + escapeAttr(product.title) + '" loading="lazy" width="120" height="120">'
        : '<div class="zan-setups__row-image" aria-hidden="true"></div>') +
      '<div>' +
      '<h4 class="zan-setups__row-title">' +
      escapeHtml(product.title) +
      '</h4>' +
      '<p class="zan-setups__row-meta">' +
      escapeHtml(variant && !product.has_only_default_variant ? variant.title : product.role) +
      '</p>' +
      '<div class="zan-setups__row-controls">' +
      variantPicker(product) +
      qtyControl(product) +
      '</div>' +
      '</div>' +
      '<div class="zan-setups__row-actions">' +
      renderItemPricing(product, eligible) +
      '<button type="button" class="zan-setups__text-btn" data-zan-toggle="' +
      escapeAttr(product.slot) +
      '">' +
      escapeHtml(product.included ? strings.remove || 'Remove' : strings.restore || 'Restore') +
      '</button>' +
      '</div>' +
      '</article>' +
      (removed ? '' : renderAltCarousel(product, alts, role)) +
      '</div>'
    );
  }

  function renderAddon(product, eligible) {
    if (!product) return '';
    const variant = getVariant(product);
    const image = (variant && variant.featured_image) || product.featured_image || '';
    const pricing = itemPricing(product, eligible);
    let priceHtml = variant ? formatMoney(variant.price) : '';

    if (pricing && pricing.discounted) {
      const saveLabel = (strings.itemSave || 'Save [amount]').replace(
        '[amount]',
        formatMoney(pricing.saved)
      );
      priceHtml =
        '<span class="zan-setups__addon-price-wrap">' +
        '<s class="zan-setups__row-list">' +
        formatMoney(pricing.list) +
        '</s>' +
        '<strong class="zan-setups__row-setup">' +
        formatMoney(pricing.setup) +
        '</strong>' +
        '<span class="zan-setups__save-badge zan-setups__save-badge--item">' +
        escapeHtml(saveLabel) +
        '</span>' +
        '</span>';
    }

    return (
      '<article class="zan-setups__addon' +
      (product.included ? ' is-added' : '') +
      '" data-slot="' +
      escapeAttr(product.slot) +
      '">' +
      (image
        ? '<img class="zan-setups__addon-image" src="' + escapeAttr(image) + '" alt="' + escapeAttr(product.title) + '" loading="lazy" width="400" height="300">'
        : '<div class="zan-setups__addon-image" aria-hidden="true"></div>') +
      '<div class="zan-setups__addon-body">' +
      '<h4 class="zan-setups__addon-title">' +
      escapeHtml(product.title) +
      '</h4>' +
      '<p class="zan-setups__addon-price">' +
      priceHtml +
      '</p>' +
      '<button type="button" class="zan-setups__addon-btn" data-zan-toggle="' +
      escapeAttr(product.slot) +
      '">' +
      escapeHtml(product.included ? strings.addedShort || 'Added' : strings.add || '+ Add') +
      '</button>' +
      '</div>' +
      '</article>'
    );
  }

  function renderConfigurator() {
    if (!state) return;

    root.querySelectorAll('[data-zan-config-title]').forEach(function (node) {
      node.textContent = state.title || '';
    });
    const fit = root.querySelector('[data-zan-config-fit]');
    if (fit) fit.textContent = state.fitReason || '';

    const image = root.querySelector('[data-zan-config-image]');
    if (image) {
      const src = state.image || (state.desk && state.desk.featured_image) || '';
      image.src = src || '';
      image.alt = state.title || '';
      image.hidden = !src;
      image.loading = 'eager';
      image.setAttribute('fetchpriority', 'high');
    }

    const eligible = calcTotals().eligible;

    if (coreRows) {
      coreRows.innerHTML =
        renderRow(state.desk, { core: true, alts: state.deskAlts, eligible: eligible }) +
        renderRow(state.chair, { core: true, alts: state.chairAlts, eligible: eligible });
    }

    if (accessoryRows) {
      accessoryRows.innerHTML = state.accessories
        .filter(function (item) { return item.included; })
        .map(function (item) { return renderRow(item, { eligible: eligible }); })
        .join('');
    }

    if (removedEl) {
      const removed = []
        .concat(state.desk && !state.desk.included ? [state.desk] : [])
        .concat(state.chair && !state.chair.included ? [state.chair] : [])
        .concat(state.accessories.filter(function (item) { return !item.included; }));
      if (removed.length) {
        removedEl.hidden = false;
        removedEl.innerHTML =
          escapeHtml(strings.removedItems || 'Removed items') +
          ': ' +
          removed
            .map(function (item) {
              return (
                '<button type="button" class="zan-setups__text-btn" data-zan-toggle="' +
                escapeAttr(item.slot) +
                '">' +
                escapeHtml(item.title) +
                '</button>'
              );
            })
            .join(', ');
      } else {
        removedEl.hidden = true;
        removedEl.innerHTML = '';
      }
    }

    if (addonRail) {
      addonRail.innerHTML = state.addons
        .map(function (item) { return renderAddon(item, eligible); })
        .join('');
    }

    if (fitPoints && fitList) {
      const points = String(state.fitPoints || '')
        .split('\n')
        .map(function (line) { return line.trim(); })
        .filter(Boolean);
      if (points.length) {
        fitPoints.hidden = false;
        fitList.innerHTML = points.map(function (point) {
          return '<li>' + escapeHtml(point) + '</li>';
        }).join('');
      } else {
        fitPoints.hidden = true;
        fitList.innerHTML = '';
      }
    }

    updateSummary();
  }

  function setSetupDetailMode(enabled) {
    document.body.classList.toggle('is-zan-setup-detail', !!enabled);
  }

  function openSetup(handle, pushState) {
    const bundle = (data.bundles || []).find(function (item) {
      return item.handle === handle;
    });
    if (!bundle) return;

    activeBundle = bundle;
    state = buildInitialState(bundle);
    catalog.hidden = true;
    config.hidden = false;
    setSetupDetailMode(true);
    if (mobileBar) mobileBar.hidden = false;
    if (mobileJump) mobileJump.classList.add('is-hidden');
    renderConfigurator();

    if (pushState !== false) {
      const url = new URL(window.location.href);
      url.searchParams.set('setup', handle);
      window.history.pushState({ zanSetup: handle }, '', url);
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function closeSetup(pushState) {
    activeBundle = null;
    state = null;
    catalog.hidden = false;
    config.hidden = true;
    setSetupDetailMode(false);
    if (mobileBar) mobileBar.hidden = true;
    if (mobileJump) mobileJump.classList.remove('is-hidden');

    if (pushState !== false) {
      const url = new URL(window.location.href);
      url.searchParams.delete('setup');
      window.history.pushState({ zanSetup: null }, '', url);
    }
  }

  function openSwap(role) {
    if (!state || !dialog) return;
    swapRole = role;
    const current = role === 'desk' ? state.desk : state.chair;
    const alts = role === 'desk' ? state.deskAlts : state.chairAlts;
    const options = [current].concat(alts).filter(Boolean);
    const title = root.querySelector('[data-zan-swap-title]');
    if (title) title.textContent = (strings.change || 'Change') + ' ' + role;

    swapOptions.innerHTML = options
      .map(function (product) {
        const variant = getVariant(product);
        const image = (variant && variant.featured_image) || product.featured_image || '';
        const isCurrent = current && product.id === current.id;
        return (
          '<article class="zan-setups__swap-option' +
          (isCurrent ? ' is-current' : '') +
          '">' +
          (image
            ? '<img src="' + escapeAttr(image) + '" alt="' + escapeAttr(product.title) + '" width="84" height="84">'
            : '<div></div>') +
          '<div>' +
          '<h4 class="zan-setups__row-title">' +
          escapeHtml(product.title) +
          '</h4>' +
          '<p class="zan-setups__row-meta">' +
          (variant ? formatMoney(variant.price) : '') +
          (variant && variant.available ? '' : ' · ' + (strings.unavailable || 'Unavailable')) +
          '</p>' +
          '</div>' +
          '<button type="button" data-zan-use-product="' +
          escapeAttr(product.slot || product.handle) +
          '"' +
          (isCurrent ? ' disabled' : '') +
          '>' +
          escapeHtml(isCurrent ? (strings.addedShort || 'Added') : strings.useThis || 'Use this') +
          '</button>' +
          '</article>'
        );
      })
      .join('');

    if (typeof dialog.showModal === 'function') dialog.showModal();
  }

  function applySwap(slot, role) {
    if (!state || !activeBundle) return;
    const pickRole = role || swapRole;
    if (!pickRole) return;

    const pool = [pickRole === 'desk' ? activeBundle.desk : activeBundle.chair]
      .concat(pickRole === 'desk' ? compact(activeBundle.deskAlts) : compact(activeBundle.chairAlts));
    const chosen = pool.find(function (item) {
      return item && (item.slot === slot || item.handle === slot || String(item.id) === String(slot));
    });
    if (!chosen) return;

    const next = Object.assign(cloneProduct(chosen), {
      quantity: 1,
      included: true,
      role: pickRole,
      slot: pickRole,
    });

    if (pickRole === 'desk') {
      state.desk = next;
      state.deskAlts = pool
        .filter(function (item) { return item && item.id !== next.id; })
        .map(function (item) {
          return Object.assign(cloneProduct(item), { included: false, role: 'desk' });
        });
    } else {
      state.chair = next;
      state.chairAlts = pool
        .filter(function (item) { return item && item.id !== next.id; })
        .map(function (item) {
          return Object.assign(cloneProduct(item), { included: false, role: 'chair' });
        });
    }

    if (dialog && dialog.open) dialog.close();
    renderConfigurator();
  }

  function accessoryUnitTotal(excludeSlot) {
    return state.accessories
      .concat(state.addons)
      .filter(function (item) {
        return item.included && item.slot !== excludeSlot;
      })
      .reduce(function (sum, item) {
        return sum + (Number(item.quantity) || 1);
      }, 0);
  }

  function maxAccessoryQty(item) {
    const remaining = MAX_ACCESSORY_UNITS - accessoryUnitTotal(item.slot);
    return Math.max(0, Math.min(MAX_ACCESSORY_UNITS, remaining));
  }

  async function addToCart() {
    const totals = updateSummary();
    if (!totals.items.length) return;

    const buttons = root.querySelectorAll('[data-zan-add]');
    const spinners = root.querySelectorAll('[data-zan-spinner]');
    buttons.forEach(function (button) { button.disabled = true; });
    spinners.forEach(function (spinner) { spinner.hidden = false; });

    const items = totals.items.map(function (item) {
      const variant = getVariant(item);
      return {
        id: variant.id,
        quantity: Number(item.quantity) || 1,
        properties: {
          _zan_setup: state.handle,
          _zan_setup_bundle: 'true',
          _zan_setup_role: item.role,
          _zan_setup_title: state.title || '',
        },
      };
    });

    try {
      const cartAddUrl = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js';
      const response = await fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ items: items }),
      });

      if (!response.ok) {
        const errorPayload = await response.json().catch(function () { return {}; });
        throw new Error(errorPayload.description || 'Unable to add setup');
      }

      document.dispatchEvent(new CustomEvent('cart:refresh'));
      if (window.jQuery) {
        window.jQuery(document).trigger('cart:refresh');
        window.jQuery(document).trigger('cart:updated');
      }

      // Open cart drawer if the theme exposes one
      try {
        if (window.T4SThemeSP && window.T4SThemeSP.Cart && typeof window.T4SThemeSP.Cart.getCart === 'function') {
          window.T4SThemeSP.Cart.getCart();
        }
        document.documentElement.dispatchEvent(new CustomEvent('cart:open'));
        document.body.classList.add('is--opend-cart');
      } catch (e) {}

      root.querySelectorAll('[data-zan-add-label]').forEach(function (label) {
        label.textContent = strings.added || 'Added to cart';
      });

      setTimeout(function () {
        updateSummary();
        buttons.forEach(function (button) { button.disabled = false; });
        spinners.forEach(function (spinner) { spinner.hidden = true; });
      }, 1600);
    } catch (error) {
      console.error(error);
      alert(error.message || 'Unable to add setup to cart');
      buttons.forEach(function (button) { button.disabled = false; });
      spinners.forEach(function (spinner) { spinner.hidden = true; });
      updateSummary();
    }
  }

  root.addEventListener('click', function (event) {
    const openBtn = event.target.closest('[data-zan-open-setup]');
    if (openBtn) {
      event.preventDefault();
      openSetup(openBtn.getAttribute('data-zan-open-setup'));
      return;
    }

    const backBtn = event.target.closest('[data-zan-back]');
    if (backBtn) {
      event.preventDefault();
      closeSetup();
      return;
    }

    const changeBtn = event.target.closest('[data-zan-change]');
    if (changeBtn) {
      openSwap(changeBtn.getAttribute('data-zan-change'));
      return;
    }

    const optionBtn = event.target.closest('[data-zan-option]');
    if (optionBtn) {
      const item = findBySlot(optionBtn.getAttribute('data-slot'));
      if (!item) return;
      const optionIndex = Number(optionBtn.getAttribute('data-option-index'));
      const value = optionBtn.getAttribute('data-value');
      const current = getVariant(item);
      const desired = variantOptionValues(current);
      if (desired[optionIndex] === value) return;
      desired[optionIndex] = value;
      const next = findMatchingVariant(item, desired, optionIndex);
      if (next) {
        item.selected_variant_id = next.id;
        renderConfigurator();
      }
      return;
    }

    const pickAlt = event.target.closest('[data-zan-pick-alt]');
    if (pickAlt) {
      if (pickAlt.classList.contains('is-current') || pickAlt.classList.contains('is-unavailable')) return;
      applySwap(pickAlt.getAttribute('data-zan-pick-alt'), pickAlt.getAttribute('data-zan-pick-role'));
      return;
    }

    const useBtn = event.target.closest('[data-zan-use-product]');
    if (useBtn) {
      applySwap(useBtn.getAttribute('data-zan-use-product'), swapRole);
      return;
    }

    const toggleBtn = event.target.closest('[data-zan-toggle]');
    if (toggleBtn) {
      const item = findBySlot(toggleBtn.getAttribute('data-zan-toggle'));
      if (item) {
        if (!item.included && accessoryUnitTotal(null) >= MAX_ACCESSORY_UNITS) {
          return;
        }
        item.included = !item.included;
        if (item.included) {
          const maxQty = maxAccessoryQty(item);
          item.quantity = Math.min(Number(item.quantity) || 1, Math.max(1, maxQty));
          if (maxQty < 1) {
            item.included = false;
          }
        }
        renderConfigurator();
      }
      return;
    }

    const qtyDec = event.target.closest('[data-zan-qty-dec]');
    const qtyInc = event.target.closest('[data-zan-qty-inc]');
    if (qtyDec || qtyInc) {
      const wrap = event.target.closest('[data-zan-qty]');
      const item = findBySlot(wrap && wrap.getAttribute('data-slot'));
      if (item) {
        const next = (Number(item.quantity) || 1) + (qtyInc ? 1 : -1);
        const maxQty = maxAccessoryQty(item);
        item.quantity = Math.min(maxQty, Math.max(1, next));
        renderConfigurator();
      }
      return;
    }

    const addBtn = event.target.closest('[data-zan-add]');
    if (addBtn) {
      addToCart();
      return;
    }

    const resetBtn = event.target.closest('[data-zan-reset]');
    if (resetBtn && activeBundle) {
      state = buildInitialState(activeBundle);
      renderConfigurator();
      return;
    }

    const closeDialog = event.target.closest('[data-zan-swap-close]');
    if (closeDialog && dialog) {
      dialog.close();
      return;
    }

    const summaryToggle = event.target.closest('[data-zan-mobile-summary-toggle]');
    if (summaryToggle) {
      const summary = root.querySelector('[data-zan-summary] .zan-setups__summary-inner');
      if (summary) {
        summary.style.display = summary.style.display === 'block' ? 'none' : 'block';
        summary.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }
  });

  root.addEventListener('change', function (event) {
    const select = event.target.closest('[data-zan-variant]');
    if (!select) return;
    const item = findBySlot(select.getAttribute('data-slot'));
    if (!item) return;
    item.selected_variant_id = select.value;
    renderConfigurator();
  });

  window.addEventListener('popstate', function () {
    const params = new URLSearchParams(window.location.search);
    const handle = params.get('setup');
    if (handle) openSetup(handle, false);
    else closeSetup(false);
  });

  if (mobileJump) {
    const grid = document.getElementById('zan-setups-grid');
    if (grid && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            mobileJump.classList.toggle('is-hidden', entry.isIntersecting);
          });
        },
        { threshold: 0.15 }
      );
      observer.observe(grid);
    }
  }

  const initial = new URLSearchParams(window.location.search).get('setup');
  if (initial) openSetup(initial, false);
})();
